import ApiBase from 'Services/Api/ApiBase';

export default new class extends ApiBase {
    route = '/human-resources/holiday';
};
